import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatISOStringToFriendlyDate } from '@frontend/features/common/helper';

interface DateDividerProps {
  date: string; // isoString;
}

export const DateDivider = ({ date }: DateDividerProps) => {
  const { t } = useTranslation();

  const today = new Date();
  const inputDate = new Date(date);
  const isToday = today.getFullYear() === inputDate.getFullYear() && 
                  today.getMonth() === inputDate.getMonth() && 
                  today.getDate() === inputDate.getDate();
  const textToDisplay = isToday ? t('common.today') : formatISOStringToFriendlyDate(date);

  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        padding: (theme) => theme.spacing(0.5, 1),
        borderRadius: 1,
        backgroundColor: (theme) => theme.palette.grey[200],
      }}
    >
      <Typography color="text.secondary" variant="subtitle2">
        {textToDisplay}
      </Typography>
    </Box>
  );
};
